import {NumberFormatter} from 'platform/locale';

import i18n from '@dms/i18n';

import {EMPTY_PLACEHOLDER} from 'shared/web';

const NO_CHANGE = 0;
const POSITIVE_SIGN = '+';

/**
 * Signed vehicle movement against the previous window. Counts stay in the invariant "ks"
 * unit rather than an inflected noun, because DMS carries no plural forms.
 */
export function formatVehiclesChangeLabel(change: number, formatNumber: NumberFormatter) {
  if (change === NO_CHANGE) {
    return i18n.t('page.salesLeague.table.vehiclesNoChange');
  }

  const formattedChange = formatNumber(change) ?? EMPTY_PLACEHOLDER;

  return i18n.t('page.salesLeague.table.vehiclesChange', {
    count: change > NO_CHANGE ? `${POSITIVE_SIGN}${formattedChange}` : formattedChange,
  });
}
